module.exports = __webpack_public_path__ + "img/chart.443e5a8a.png";